var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.iconComponent,{tag:"component",class:['size',_vm.className, _vm.variant]})
}
var staticRenderFns = []

export { render, staticRenderFns }